/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 给评论点赞或者取消点赞
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PraiseParams {
  constructor(public commentId: string) {}
}

export default async function (
  params: PraiseParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.CommentLikeDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/cms/cloundtheater-comments/praise`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
